import(/* webpackMode: "eager" */ "/vercel/path0/app/(mitra)/search/[...search_id]/page.js")